<template>
  <div ref="wrapper" class="image-wrapper">
    <div ref="canvasWrapper" class="layers-wrapper">
      <zoomer
        v-if="canvasLength"
        class="layer layer1"
        :class="{'active-layer': mode === 'drag'}"
        :width="canvasLength"
        :height="canvasLength"
        :image="image"
        :scale="scale"
        @ratio="ratio = $event"
        @position="imagePosition = $event"
        @input="afterZoomingLayer = $event"
      ></zoomer>
      <erazer
        v-if="canvasLength"
        class="layer layer2"
        :class="{'active-layer': mode === 'erase'}"
        :width="canvasLength"
        :height="canvasLength"
        :image-position="imagePosition"
        :layer="afterZoomingLayer"
        @input="afterErazingLayer = $event"
      ></erazer>
      <cropper
        v-show="mode === 'crop'"
        v-if="canvasLength"
        ref="cropper"
        class="layer layer3"
        :class="{'active-layer': mode === 'crop'}"
        :width="canvasLength"
        :height="canvasLength"
        :image-position="safeImagePosition"
        :ratio="ratio"
        :points="points"
        :layer="afterErazingLayer"
        @input="emitBlob($event)"
      ></cropper>
    </div>
    <div v-if="image" class="controls">
      <div class="btn-group btn-group-toggle">
        <label for="crop" class="btn btn-secondary control-btn" :class="{active: mode === 'crop'}">
          <input id="crop" v-model="mode" type="radio" value="crop" name="options" aria-label="Crop">
          <slot name="crop">
          </slot>
        </label>
        <label for="erase" class="btn btn-secondary control-btn" :class="{active: mode === 'erase'}">
          <input id="erase" v-model="mode" type="radio" value="erase" name="options" aria-label="Erase">
          <slot name="erase">
          </slot>
        </label>
        <label for="drag" class="btn btn-secondary control-btn" :class="{active: mode === 'drag'}">
          <input id="drag" v-model="mode" type="radio" value="drag" name="options" aria-label="Drag">
          <slot name="drag">
          </slot>
        </label>
        <label class="btn btn-secondary control-btn" @click="zoomIn">
          <slot name="zoomIn">
          </slot>
        </label>
        <label class="btn btn-secondary control-btn" @click="zoomOut">
          <slot name="zoomOut">
          </slot>
        </label>
      </div>
    </div>
  </div>
</template>

<script>
import Erazer from './Erazer.vue'
import Cropper from './Cropper.vue'
import Zoomer from './Zoomer.vue'

export default {
  name: 'image-drawer',
  components: { Zoomer, Cropper, Erazer },
  props: {
    image: HTMLImageElement,
    points: Array
  },
  data () {
    return {
      mode: 'crop',
      canvasLength: 0,
      imagePosition: null,
      ratio: null,
      afterZoomingLayer: null,
      afterErazingLayer: null,
      afterCroppingLayer: null,
      scale: 1,
      scaleStep: 1.05
    }
  },
  computed: {
    safeImagePosition () {
      if (this.image && this.imagePosition) {
        return {
          x0: Math.max(this.imagePosition.x0, 0),
          x1: Math.min(this.imagePosition.x1, this.canvasLength),
          y0: Math.max(this.imagePosition.y0, 0),
          y1: Math.min(this.imagePosition.y1, this.canvasLength)
        }
      }
      return null
    }
  },

  watch: {
    mode (val) {
      if (val === 'drag') {
        this.$refs.cropper.freezeDots(true)
      } else {
        this.$refs.cropper.freezeDots(false)
      }
    }
  },

  mounted () {
    setTimeout(() => {
      this.canvasLength = this.$refs.wrapper.offsetWidth
    }, 200)

    if (this.$refs.canvasWrapper.offsetWidth) {
      this.$refs.canvasWrapper.style.height = this.$refs.canvasWrapper.offsetWidth + 'px';
    }
  },

  methods: {
    emitBlob (layer) {
      if (layer) {
        layer.ctx.canvas.toBlob(blob => {
          this.$emit('input', blob)
        }, 'image/jpeg')
      } else {
        this.$emit('input', null)
      }
    },
    zoomIn () {
      this.scale = parseFloat((this.scale + this.scaleStep).toFixed(2))
    },
    zoomOut () {
      this.scale = parseFloat((this.scale - this.scaleStep).toFixed(2))
    }
  }
}
</script>
